import { UPDATE_ROOM_ERROR } from "./error-codes.constants";
import ApiError from "../../errors/ApiError";

export class UpdateRoomError extends ApiError {
  constructor() {
    super(UPDATE_ROOM_ERROR);
  }
}
